import React from 'react'
import { Button, Grid, Hide, PageSection } from '@superhi/design'

import LibraryPostArticleCard from '../../../../../../components/LibraryPostArticleCard'
import LibraryPostVideoCard from '../../../../../../components/LibraryPostVideoCard'
import { buildPath } from '../../../../../../routing'

import { CurrentWrapper } from './styles'

type LibraryPost =
  | React.ComponentProps<typeof LibraryPostVideoCard>
  | React.ComponentProps<typeof LibraryPostArticleCard>

type Props = {
  slug: string
  posts: LibraryPost[]
  currentPostSlug: string
}

const GRID_1_SLIDER = { small: true, medium: true }
const GRID_1_CELL_SPAN_1: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 3,
  medium: 3,
}

const MAX_POSTS = 6

const Series: React.FC<Props> = ({ slug, currentPostSlug, posts = [] }) => (
  <Hide data-component-name="Series" at={['large', 'xlarge']}>
    <PageSection
      title="Also in this series"
      align="left"
      headingLevel={2}
      backgroundColor="pink"
      footer={
        posts.length > MAX_POSTS && (
          <Button href={buildPath('series-view', { params: { seriesSlug: slug } })}>
            View all {posts.length} posts
          </Button>
        )
      }
    >
      <Grid slider={GRID_1_SLIDER}>
        {posts.slice(0, MAX_POSTS).map((post): React.ReactElement => {
          switch (post.__typename) {
            case 'LibraryPostArticle': {
              return (
                <Grid.Cell key={post.slug} span={GRID_1_CELL_SPAN_1}>
                  {post.slug === currentPostSlug ? (
                    <CurrentWrapper>
                      <LibraryPostArticleCard {...post} headingLevel="3" imageLazy />
                    </CurrentWrapper>
                  ) : (
                    <LibraryPostArticleCard {...post} headingLevel="3" imageLazy />
                  )}
                </Grid.Cell>
              )
            }
            case 'LibraryPostVideo': {
              return (
                <Grid.Cell key={post.slug} span={GRID_1_CELL_SPAN_1}>
                  {post.slug === currentPostSlug ? (
                    <CurrentWrapper>
                      <LibraryPostVideoCard {...post} imageLazy />
                    </CurrentWrapper>
                  ) : (
                    <LibraryPostVideoCard {...post} imageLazy />
                  )}
                </Grid.Cell>
              )
            }
          }
        })}
      </Grid>
    </PageSection>
  </Hide>
)

export default Series
